import axios from "axios";
import store from "@/vue/store";
import oktaAuth from "@/okta-auth";
import { getEnv } from "@/env";

const oktaAxios = axios.create({
  baseURL: getEnv("VUE_APP_API_V2_URL"),
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

oktaAxios.interceptors.request.use(async (config) => {
  // By default, if we have a token in the store, let's use that for authenticated requests
  const token = oktaAuth.getAccessToken();
  if (!token) {
    throw new Error("No token found");
  }
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});
export const apiErrorHandler = (e) => {
  if (e.response && e.response.data && e.response.data.message) {
    console.error(e); // Print previous error for debugging
    throw new Error(e.response.data.message);
  }
  throw e;
};

const axiosInstance = axios.create({
  baseURL: getEnv("VUE_APP_API_URL"),
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(async (config) => {
  if (!store.getters.getCustomer.customerName) {
    return config;
  }
  const token = store.getters.getCustomer.accessToken;
  config.headers.Authorization = `Bearer ${token}`;
  config.headers.token = token;
  return config;
});

// Response interceptor for API calls
axiosInstance.interceptors.response.use(
  async (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    console.log("before refresh token");
    console.log(store.getters.getCustomer.customerName);
    console.log(originalRequest);

    let isTokenValid =
      store.getters.getCustomer.exp * 1000 > new Date().getTime();

    if (error.response && [401, 400].includes(error.response.status)) {
      isTokenValid = false;
    }

    if (
      store.getters.getCustomer.customerName &&
      !isTokenValid &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      const refreshPayload = {
        ...store.getters.getCustomer,
        customerId: store.getters.getCustomer.cid,
      };
      await store.dispatch("fetchCustomer", refreshPayload);
      return axiosInstance.request(originalRequest);
    }
    console.log("refresh token after");
    return Promise.reject(error);
  }
);

// Add custom configuration here.
const smpAxiosInstance = axios.create({
  baseURL: getEnv("VUE_APP_SMP_API_URL"),
  withCredentials: false,
  headers: {
    "Content-Type": "application/json",
  },
});

smpAxiosInstance.interceptors.request.use(
  async (config) => {
    try {
      smpAxiosInstance.defaults.headers.common["Authorization"] =
        "Bearer " + store.getters.getCustomer.accessToken;
    } catch (e) {
      console.log("interceptor error");
      console.log(e);
    }
    return config;
  },
  function (error) {
    // Do something with request error
    console.log("smp client error");
    console.log(error);
    return Promise.reject(error);
  }
);

smpAxiosInstance.interceptors.response.use(
  async (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    let isTokenValid =
      store.getters.getCustomer.exp * 1000 > new Date().getTime();

    if (
      store.getters.getCustomer.customerName &&
      !isTokenValid &&
      !originalRequest._retry
    ) {
      console.log("refreshing token");
      originalRequest._retry = true;
      return store.dispatch("fetchCustomer", {
        customerId: store.getters.getCustomer.cid,
        pbx: store.getters.getCustomer.pbx,
        customerName: store.getters.getCustomer.customerName,
        tenantInfo: store.getters.getCustomer.tenantInfo,
        success: (response) => {
          console.log("got lockCustomer in refrsh token smpAxiosInstance");
          console.log(response);
          originalRequest.headers["Authorization"] =
            "Bearer " + store.getters.getCustomer.accessToken;

          return new Promise((resolve, reject) => {
            smpAxiosInstance
              .request(originalRequest)
              .then((res) => {
                console.log("SMP resolving original response");
                console.log(res);
                resolve(res);
              })
              .catch((e) => {
                reject(e);
              });
          });
        },
        error: (err) => {
          console.log("got error lockCustomer");
          return Promise.reject(err);
        },
      });
    }
    return Promise.reject(error);
  }
);

export { oktaAxios, axiosInstance, smpAxiosInstance };
